import { render, staticRenderFns } from "./video-play.vue?vue&type=template&id=3d1e52f4&scoped=true&"
import script from "./video-play.vue?vue&type=script&lang=js&"
export * from "./video-play.vue?vue&type=script&lang=js&"
import style0 from "./video-play.vue?vue&type=style&index=0&id=3d1e52f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1e52f4",
  null
  
)

export default component.exports